import React from "react"
import { useSnackbar } from "notistack"
import { useAuthUser } from "../../hooks/use-auth-user"
import { useHistory } from "react-router-dom"
import { paths } from "../../../paths"

export const useConfirmDeleteAccount = ({ deleteErrorMessage }: Params) => {
  const history = useHistory()
  const { enqueueSnackbar } = useSnackbar()
  const { user, onDeleteAccount } = useAuthUser()
  const [dialogOpen, setDialogOpen] = React.useState(false)
  const [status, setStatus] = React.useState<Status>("idle")
  const [confirmationText, setConfirmationText] = React.useState("")
  const [confirmPassword, setConfirmPassword] = React.useState("")
  const email = user?.email || ""

  const isIdle = status === "idle"
  const isDeleting = status === "pending"
  const disableDeletion = !isIdle || isDeleting || !confirmPassword
  const closeDialog = () => {
    setDialogOpen(false)
    setConfirmationText("")
    setConfirmPassword("")
  }
  const openDialog = () => setDialogOpen(true)

  const confirmAndCloseDialog = async () => {
    try {
      await onDeleteAccount({ confirmPassword })
      history.push(paths.accountDeleted())
    } catch (error: any) {
      setStatus("error")
      enqueueSnackbar(error?.message, { variant: "error", onClose: () => setStatus("idle") })
    }
  }

  return {
    dialogOpen,
    setDialogOpen,
    status,
    confirmationText,
    email,
    confirmPassword,
    setConfirmationText,
    setConfirmPassword,
    isIdle,
    isDeleting,
    disableDeletion,
    closeDialog,
    openDialog,
    confirmAndCloseDialog,
  }
}

type Params = {
  deleteErrorMessage: string
}

type Status = "idle" | "success" | "pending" | "error"
